import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AgrupamentosService } from 'src/app/service/agrupamentos.service';
import { AlertService } from 'src/app/service/alert.service';
import { ProdutosService } from 'src/app/service/produtos.service';
import { UsuariosService } from 'src/app/service/usuarios.service';
import { ListaUsuariosComponent } from '../lista-usuarios/lista-usuarios.component';
import { ClientesService } from 'src/app/service/clientes.service';
import { TiposAgrupamentosService } from 'src/app/service/tipos-agrupamentos.service';

@Component({
  selector: 'app-criar-agrupamentos',
  templateUrl: './criar-agrupamentos.component.html',
  styleUrls: ['./criar-agrupamentos.component.css']
})
export class CriarAgrupamentosComponent implements OnInit {

  etapa = 1;
  loader = false;
  clientes = [] as any;
  produtos = [] as any;
  usuarios = [] as any;
  tiposAgrupamentos = [] as any;
  form = this.formBuilder.group({
    vc_nome: new FormControl('', [Validators.required, Validators.pattern(/^(?!\s+$).+/)]),
    fk_tipo_agrupamento: new FormControl('', [Validators.required]),
    fk_produto: new FormControl('', [Validators.required]),
    ar_usuarios: new FormControl([], [Validators.required]),
    ar_clientes: new FormControl([], [Validators.required]),
  })
  exibirUsuario = false
  exibirCliente = false
  exibirDadosSelecionados = false;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private produtoService: ProdutosService,
    private agrupamentoService: AgrupamentosService,
    private usuarioService: UsuariosService,
    private clientesService: ClientesService,
    private tiposAgrupamentosService: TiposAgrupamentosService,
  ) { }

  ngOnInit(): void {
    this.acharProduto();
    this.acharTipoDoAgrupamento();
  }

  acharProduto(){
    this.produtoService.listarService().subscribe((resp: any) => {
      this.produtos = resp.filter(function (elem: any) {
        return elem.sr_id != 1
      })
    }, error => {
      this.redirecionaComErro("Não foi possível encontrar os produtos.");
    })
  }

  acharTipoDoAgrupamento(){
    this.tiposAgrupamentosService.listarTiposDeAgrupamento().subscribe((resp: any) => {
      this.tiposAgrupamentos = resp
    }, error => {
      this.redirecionaComErro("Não foi possível encontrar os tipos de agrupamento.");
    })
  }

  buscarUsuarios(){
    this.loader = true
    this.usuarioService.listarUsuariosAgrupamentos().subscribe((resp:any) => {
      this.loader = false
      this.usuarios = resp
    }, error => {
      this.loader = false
      this.redirecionaComErro("Não foi possível encontrar os usuários.");
    })
  }

  encontrandoDadoDoTipoDeAgrupamento(){
    if (this.form.value.fk_tipo_agrupamento == '1'){
      this.exibirUsuario = true
      this.buscarUsuarios();
    }
  }

  redirecionaComErro(mensagem:string){
    this.alertService.error(mensagem);
    this.router.navigate(['configuracao/agrupamentos']);
  }

  receberUsuarios(valor:any) {
    const arrayIdUsuarios = valor.map((usuario:any) => {
      return usuario.sr_id
    })
    this.usuarios = valor;
    this.form.get('ar_usuarios')?.setValue(arrayIdUsuarios)
    this.exibirUsuario = false
    this.exibirCliente = true
    this.listarClientes()
  }

  listarClientes(){
    this.loader = true
    let usuariosString = this.form.get('ar_usuarios')?.value.join(",")
    this.clientesService.listarClientesEmComumEntreUsuarios(usuariosString).subscribe((resp:any) => {
      this.loader = false
      this.clientes = resp
    }, err => {
      this.loader = false
      this.redirecionaComErro("Não foi possível encontrar os clientes.");
    })
  }

  receberCliente(valor:any){
    const arrayIdUsuarios = valor.map((cliente: any) => {
      return cliente.sr_id
    })
    this.clientes = valor;
    this.form.get('ar_clientes')?.setValue(arrayIdUsuarios)
    this.exibirCliente = false;
    this.exibirDadosSelecionados = true;
  }

  cadastrar(){
    this.agrupamentoService.cadastrarAgrupamento(this.form.value).subscribe((resp:any) => {
      this.alertService.success(resp.mensagem);
      this.router.navigate(['configuracao/agrupamentos']);
    })
  }

  cancel(){
    this.router.navigate(['configuracao/agrupamentos']);
  }
}
